import Vue from 'vue';
import store from '@/store';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const attachmentService = {
  doAttachment(referenceNumber, formData) {
    return Vue.axios.post(`/attachments/${referenceNumber}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  async getAttachments(referenceNumber, ownerType) {
    return await Vue.axios.get(`/attachments/${referenceNumber}?type=${ownerType}`);
  },
  async download(attachmentId, originalName) {
    let response;
    try {
      response = await Vue.axios({
        url: `/attachments/${attachmentId}/download`,
        method: 'GET',
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', originalName);
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      const status = e.status;
      let message;
      switch (status) {
        case 403:
          message = i18n.t('attachments.errors.forbiddenView');
          break;
        case 404:
          message = i18n.t('attachments.errors.notFound');
          break;
        default:
          message = i18n.t('attachments.errors.unknown', { status });
      }

      store.dispatch(TolErrorsActions.SetError, { message });
    }
  },
  async deleteAttachment(attachmentId, isUserReport = false) {
    let response;
    let request = isUserReport
      ? `/attachments/${attachmentId}?is-user-report=true`
      : `/attachments/${attachmentId}`;
    try {
      response = await Vue.axios.delete(request);
    } catch (e) {
      const status = e.status;
      let message;
      switch (status) {
        case 403:
          message = i18n.t('attachments.errors.forbiddenDelete');
          break;
        case 404:
          message = i18n.t('attachments.errors.notFound');
          break;
        default:
          message = i18n.t('attachments.errors.unexpected', { status });
      }

      store.dispatch(TolErrorsActions.SetError, { message });
    }
    return response;
  },
  async updateAttachmentCategory(attachmentId, category) {
    return Vue.axios.post(`/attachments/update-category/`, {
      id: attachmentId,
      category: category
    });
  }
};
